import {
  NewsSource,
  Review
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { memo } from "react"

import { ComponentProps } from "."
import Item from "./Item"
import { Ul } from "./styled"

const List = ({
  display,
  flagLoading,
  isShowFlagButton,
  label,
  name,
  onSelect,
  onToggleFlagged,
  selected
}: ComponentProps) => (
  <Ul aria-label={label}>
    {display.map(({ id, isFlagged, url, ...item }) => (
      <Item
        flagLoading={flagLoading}
        id={id}
        isFlagged={isFlagged}
        isShowFlagButton={isShowFlagButton}
        key={id}
        label={(item as Review).title ?? (item as NewsSource).name ?? url}
        name={name}
        onSelect={onSelect}
        onToggleFlagged={onToggleFlagged}
        selected={selected}
        url={url}
      />
    ))}
  </Ul>
)

export default memo(List)
